import { makeStyles, useTheme, createStyles } from '@material-ui/core';
import React from 'react';
import SwipeableViews from 'react-swipeable-views';
import Box from '@mui/material/Box';
import { ArrowCarousel } from './ArrowCarousel';
import classNames from 'classnames';
import { serverConfig } from '../../../utils/config';
import { CameraAltOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { Star } from "@material-ui/icons";
import StarBorderIcon from '@mui/icons-material/StarBorder';
// import { useTranslation } from 'react-i18next';

const Env = serverConfig;
export const PreviewImage = (props: any) => {
	const theme = useTheme()
	const classes = useStyles()
	const [activeStep, setActiveStep] = React.useState(0)
	const [t] = useTranslation<'common'>()
	const maxSteps = props?.photos?.length ?? 1
	let usage= props.usage; 

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	}

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleStepChange = (step: number) => {
		setActiveStep(step);
	};
	const havePrevious = !(activeStep === 0)
	const haveNext = !(activeStep === maxSteps - 1)
	// const { t } = useTranslation<'common'>();
	let placement:any=[]

	// Check if it's a hotel and get its star rating
	const isHotel = props.data?.property?.type?.name === "Hôtel";
	const hotelStars = isHotel ? (props.data?.property?.hotel?.stars || 0) : 0;
	const filledStars = Math.min(Math.max(0, hotelStars), 5); // Ensure rating is between 0-5
	const emptyStars = 5 - filledStars;

/*
	if (props.data?.annonceBoosterData) {
    props.data.annonceBoosterData.forEach((boost: any) => {
        boost.adsparamData.forEach((seach: any) => {
            if (seach.placement === "SearchPage") {
                placement.push(true);
            }
        });
    });
} else {
    console.warn("annonceBoosterData is undefined or null");
}
*/

	return (
		<div className={classes.my_carousel}>
			<SwipeableViews
				axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
				index={activeStep}
				onChangeIndex={handleStepChange}
				enableMouseEvents
				style={{height:"100%"}}
				className={classes.swipeable}
			>
				{props.photos && props.photos.map((step: any, index: any) => {
				return (
					<div style={{height: "100%", maxHeight: 400}}>
						{
							<Box className={classes.imageContainer} style={{ backgroundImage: `url("${`${Env.ApiRoot}/images/properties/${step.filename}`}")` }} position="relative">
								 {isHotel && hotelStars > 0 && (
									<Box className={classes.ratingContainer}>
										{[...Array(filledStars)].map((_, i) => (
											<Star key={`filled-${i}`} className={classes.starIcon} style={{ color: '#FFD700' }} />
										))}
										{[...Array(emptyStars)].map((_, i) => (
											<StarBorderIcon key={`empty-${i}`} className={classes.starIcon} style={{ color: '#FFD700' }} />
										))}
									</Box>
								)}		
								{usage !== "announceSlider" && (
									<Stack 
										className={classes.previewCountContainer} 
										direction="row" 
										padding={1} 
										left={props.isExeptional ? 20 : 16}
										bottom={16}
									>
										<CameraAltOutlined sx={{ color: "#fff", marginRight: 1 }} />
										<Typography className={classes.nombre}>{maxSteps}</Typography>
									</Stack>
								)}
								{props.isExeptional && !props.ambassador &&
									<>
										<Box className={classes.exeptionContainer}>
											<svg width="222" height="40" viewBox="0 0 222 40" fill="none">
												<path d="M0 0L210 5.5L221.5 30L0 40V0Z" fill="#EEBA41" fillOpacity="0.86" />
											</svg>
											<Box className={classes.exeptionContainerText}>
												{props.dealText}
											</Box>
										</Box>
										
									</>
								}
								{props.isExeptional && props.ambassador &&
									<>
										<Box className={classes.exeptionContainer}>
											<svg width="222" height="40" viewBox="0 0 222 40" fill="none">
												<path d="M0 0L210 5.5L221.5 30L0 40V0Z" fill="#EEBA41" fillOpacity="0.86" />
											</svg>
											<Box className={classes.exeptionContainerText}>
												{props.dealText}
											</Box>
										</Box>
										<Box className={classes.exeptionContainerAmbassador}>
											{/* <svg width="222" height="40" viewBox="0 0 222 40" fill="none">
												<path d="M0 0L210 5.5L221.5 30L0 40V0Z" fill="#ffffff" fillOpacity="0.86" />
											</svg> */}
											<Box className={classes.ambassadorText}>
												{t('search.ambassador')}
											</Box>
										</Box> 
									</>
								}
								{props.ambassador && !props.isExeptional &&
									<>
										<Box className={classes.exeptionContainerAmbassador}>
											{/* <svg width="222" height="40" viewBox="0 0 222 40" fill="none">
												<path d="M0 0L210 5.5L221.5 30L0 40V0Z" fill="#ffffff" fillOpacity="0.86" />
											</svg> */}
											<Box className={classes.ambassadorText}>
												{t('search.ambassador')}
											</Box>
										</Box> 
										{/* {
											props.data.annonceBooster!==undefined && placement[0]!==undefined ?
											props.data.annonceBooster[0]!==undefined && placement[0] ?
											<div className={classes.sponsorDeal}>
												<svg width="222" height="40" viewBox="0 0 222 40" fill="none">
													<path d="M0 0L210 5.5L221.5 30L0 40V0Z" fill="rgb(238, 186, 65)" fillOpacity="0.86" />
												</svg>
												<span className={classes.exeptionContainerText}>{t('prevImage.labels.sponsorisee')}</span>
											</div> : "":""
										} */}
										
									</>
								}
								{/* {
									props.data.annonceBooster!==undefined && placement[0]!==undefined ?
									props.data.annonceBooster[0]!==undefined && placement[0] && !props.isExeptional ?
									<div className={classes.sponsor}>
										<svg width="222" height="40" viewBox="0 0 222 40" fill="none">
											<path d="M0 0L210 5.5L221.5 30L0 40V0Z" fill="rgb(238, 186, 65)" fillOpacity="0.86" />
										</svg>
										<span className={classes.exeptionContainerText}>{t('prevImage.labels.sponsorisee')}</span>
									</div>: "":""

								} */}
								
							</Box>

						}
					</div>
				)})}
			</SwipeableViews>
			{havePrevious && <div className={classNames(classes.previous, 'prev_next')}>
				<ArrowCarousel direction="left" onClick={handleBack} />
			</div>}
			{haveNext && <div className={classNames(classes.next, 'prev_next')}>
				<ArrowCarousel direction="right" onClick={handleNext} />
			</div>}
		</div>
	)
}



const useStyles = makeStyles(() => createStyles({
	swipeable: {
		"& > .react-swipeable-view-container": {
			height: "100% !important"
		}
	},
	previewCountContainer: {
		borderRadius: 8,
		position: "absolute",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "rgba(0,0,0,0.3)",
		color: "#fff",
		bottom: "40px !important"
	},
	nombre: {
		marginBottom: 40,
	},
	previous: {
		position: 'absolute',
		top: '40%',
		left: 5,
		opacity: 0,
		transition: 'opacity .3s',
		background: "rgb(234, 118, 6)",
		borderRadius: "50%"
	},
	exeptionContainer: {
		position: "absolute",
		left: 0,
		top: 22
	},
	exeptionContainerAmbassador: {
		position: "absolute",
		left: 16,
		bottom: 8
	},
	sponsor: {
		position: "absolute",
		color: "white",
		top: 22,
		display: "flex",
		alignItems: "center"
	},
	sponsorDeal: {
		position: "absolute",
		color: "white",
		top: 64,
		display: "flex",
		alignItems: "center"
	},
	sponsorText: {
		position: "absolute",
		top: 15
	},
	imageContainer: {
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
		height: "100%",
		overflow: "hidden"
	},
	next: {
		position: 'absolute',
		top: '40%',
		right: 5,
		opacity: 0,
		transition: 'opacity .3s',
		background: "rgb(234, 118, 6)",
		borderRadius: "50%"
	},
	photo: {
		position: 'absolute',
		bottom: 5,
		left: 5,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		borderRadius: 4,
		padding: '0 4px',
		display: 'flex',
		alignItems: 'center'
	},
	exeptionContainerText: {
		top: 0,
		left: 0,
		position: "absolute",
		width: "100%",
		height: "100%",
		alignItems: "center",
		justifyContent: "center",
		fontSize: 18,
		fontWeight: "bold",
		color: "#fff",
		marginTop: 10,
		marginLeft: 18,
	},
	ambassadorText: {
		width: "100%",
		height: "100%",
		alignItems: "center",
		justifyContent: "center",
		fontSize: 18,
		fontWeight: "bold",
		color: "#000",
		background: "#ffffff9A",
		padding: "8px 10px",
		borderRadius: 4
	},
	my_carousel: {
		height: "100%",
		position: "relative",
		'&:hover': {
			'& .prev_next': {
				opacity: 1
			}
		}
	},
	ratingContainer: {
		position: 'absolute',
		top: 16,
		right: 16,
		display: 'flex',
		alignItems: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		padding: '6px 10px',
		borderRadius: 4,
		zIndex: 1,
		backdropFilter: 'blur(2px)'
	},
	starIcon: {
		fontSize: '1.2rem',
		margin: '0 2px'
	},
}))
